import React, { Component } from 'react'
import ScrollToTop from '../../../../components/ScrollToTop'
import MenuSider from '../../../../components/MenuSider'
import { connect } from 'react-redux'
import IntlMessages from '../../../../util/IntlMessages';
import { Form, Button, Collapse, Icon, Table, Spin, Upload, Modal, message } from 'antd';
import { Link } from 'react-router-dom'
import './Summary.css'
import axios from 'axios'
import { Constants, Filestream_Url } from '../../../../Constants/Constants'


const Panel = Collapse.Panel;

class Summary extends Component {
    constructor() {
        super();

        var job2 = JSON.parse(window.localStorage.getItem('Jobtype'))
        var select_job2 = JSON.parse(window.localStorage.getItem('select_job'))
        const cate = JSON.parse(window.localStorage.getItem('Category'))
        const type_category = JSON.parse(window.localStorage.getItem("type_of_category"))
        var root_cause2 = JSON.parse(window.localStorage.getItem('Rootcause'))

        this.state = {
            job: job2,
            select_job: select_job2,
            category: cate,
            type_of_category: type_category,
            root_cause: root_cause2,
            type_of_observe: "",
            detail_safe1: "-",
            detail_unsafe1: "-",
            detail_unsafe2: "-",
            loading: false,
            fileList: [],
            previewVisible: false,
            previewImage: '',
            submit_success: false,
            error_message: '',
            mode: 'create'
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.insert_newobservation_image = this.insert_newobservation_image.bind(this)
    }
    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }
    componentWillMount() {
        //detail from action page
        // console.log(this.props.location.state.type_of_observe)
        let mode = (this.props.location.state || {}).mode || 'create'
        this.setState({ mode: mode })
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        const type_of_observe2 = this.props.location.state.type_of_observe

        this.setState({
            type_of_observe: type_of_observe2
        })
        if (type_of_observe2 === "Unsafe") {
            var detail_unsafe = JSON.parse(window.localStorage.getItem("detail_unsafe"))
            var detail_unsafe_1 = detail_unsafe.detail1
            var detail_unsafe_2 = detail_unsafe.detail2
            if (detail_unsafe_1 !== "") {
                this.setState({
                    detail_unsafe1: detail_unsafe_1
                })
            }
            if (detail_unsafe_2 !== "") {
                this.setState({
                    detail_unsafe2: detail_unsafe_2
                })
            }

        } else {
            var detail_safe = JSON.parse(window.localStorage.getItem("detail_safe"))
            var detail_safe_1 = detail_safe.detail
            if (detail_safe_1 !== "") {
                this.setState({
                    detail_safe1: detail_safe_1
                })
            }
        }
        this.getErrorMessage()
        // var detail = this.props.location.state
        this.setImage()
    }

    setImage() {
        this.setState({
            fileList: this.props.set_checklist.upload
        })
    }

    handleChange = ({ fileList }) => {
        this.setState({
            fileList: fileList
        })
    }

    getErrorMessage() {
        axios.get('config.json').then(res => {
            this.setState({
                error_message: res.data.error_message
            })
        })
    }

    insert_newobservation_image() {
        // console.log(this.state.fileList)
        this.setState({ loading: true })
        var data = new FormData();
        var Token
        var List_image = []
        if (this.state.fileList.length !== 0) {
            axios.get(Constants.BASE_URL + 'api/FileStream/Gettoken')
                .then((response) => {
                    Token = response.data
                    let file_list = this.state.fileList
                    let list_img = file_list.filter(x => x.url === undefined)
                    list_img.map(l => {
                        data.append('file', l.originFileObj);
                    })
                    // for (var i = 0; i < list_img; i++) {
                    //     debugger
                    //     if (this.state.fileList[i].originFileObj !== undefined)
                    //         data.append('file', this.state.fileList[i].originFileObj);
                    // }
                    let filestream_Url = Filestream_Url + 'Api/UploadFile/Upload'
                    axios({
                        method: 'POST',
                        //url: 'https://scgchem-so.scg.com/filestreamso/Api/UploadFile/Upload',
                        url: filestream_Url,
                        data: data,
                        config: { headers: { 'Content-Type': 'multipart/form-data' } },
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }).then((response) => {
                        let file_list = this.state.fileList
                        let list_img = file_list.filter(x => x.url !== undefined)
                        list_img.map(l => {
                            List_image.push(l.uid)
                            return true
                        })
                        response.data.map((l, i) => {
                            List_image.push(l.guid)
                            return true
                        })
                        this.handleSubmit(List_image)
                    }, (error) => { console.log(error) })
                }, (error) => { console.log(error) })
        } else {
            List_image = []
            this.handleSubmit(List_image)
        }
    }

    handleSubmit = (List_image) => {
        var state = JSON.parse(window.localStorage.getItem('state'))
        var basic_info = state.set_basic_info

        var sel_job_1 = JSON.parse(window.localStorage.getItem('select_job'))
        var job_type = JSON.parse(window.localStorage.getItem('Jobtype'))

        let type_of_category = this.state.type_of_category

        var select_job = []
        job_type.map((l, i) => {
            if (sel_job_1[i].factory === 1 || sel_job_1[i].office === 1) {
                select_job.push({ JobType: l.JobType1, PKJobTypeID: l.PKJobTypeID })
            }
            return true
        })

        const Detail_Category1 = JSON.parse(window.localStorage.getItem("Detail_Category"))
        const near_miss = JSON.parse(window.localStorage.getItem("nearmiss"))
        var Detail_Category = []
        Detail_Category1.map((l, i) => {
            if (l.rule && type_of_category.filter(x => x.cat_id === l.category_ID && x.type === 'Unsafe').length > 0) {
                Detail_Category[i] = { category_ID: l.category_ID, detail: l.detail, near_miss: near_miss, root_cause: l.root_cause, type_category: "Unsafe" }
            } else if (type_of_category.filter(x => x.cat_id === l.category_ID && x.type === 'Safe').length > 0) {
                Detail_Category[i] = { category_ID: l.category_ID, detail: l.detail, near_miss: near_miss, root_cause: l.root_cause, type_category: "Safe" }
            } else {
                Detail_Category[i] = { category_ID: l.category_ID, detail: l.detail, near_miss: near_miss, root_cause: l.root_cause, type_category: "" }
            }

            return true
        })

        const sel_sub_cate = JSON.parse(window.localStorage.getItem('Select_Category'))
        var select_sub_category = []
        var count_sub_cate_selected = 0
        sel_sub_cate.map((l, i) => {
            switch (l.status) {
                case 1: select_sub_category[count_sub_cate_selected] = { sub_category_ID: l.subcate_id, safe: 1, unsafe: 0 }
                    count_sub_cate_selected++
                    break;
                case 2: select_sub_category[count_sub_cate_selected] = { sub_category_ID: l.subcate_id, safe: 0, unsafe: 1 }
                    count_sub_cate_selected++
                    break;
                default:
                    break;
            }

            return null
        })

        const detail_safe = JSON.parse(window.localStorage.getItem("detail_safe"))
        const detail_unsafe = JSON.parse(window.localStorage.getItem("detail_unsafe"))
        var detail_safe1 = detail_safe.detail
        var detail_unsafe1 = detail_unsafe.detail1
        var detail_unsafe2 = detail_unsafe.detail2

        var nearmiss = JSON.parse(window.localStorage.getItem("nearmiss"))

        const detail_capa = JSON.parse(window.localStorage.getItem("detail_capa"))


        var userid = state.authen.UserID
        var data = basic_info
        data.userid = userid
        data.select_job = select_job
        data.detail_category = Detail_Category
        data.select_sub_category = select_sub_category
        data.detail_safe1 = detail_safe1
        data.detail_unsafe1 = detail_unsafe1
        data.detail_unsafe2 = detail_unsafe2
        data.image = List_image
        data.nearmiss = nearmiss
        data.areaid = this.props.set_basic_info.areaid
        data.user_responsible = detail_capa.user.userId
        data.responsible_manager = detail_capa.user.manager
        data.manager_email = detail_capa.user.managerEmail
        data.type = detail_capa.type
        data.due_date = detail_capa.due_date
        data.user = detail_capa.user
        data.capa_action = detail_capa.capa_action

        var ObtranEn = JSON.stringify(data)

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.post(Constants.BASE_URL + "api/ObservationTransaction/PostSendingStatus", { Obtran: ObtranEn }, tokenHeader)
                .then((response) => {
                    if (response.data === '') {
                        this.setState({
                            loading: false,
                        })
                        message.error(this.state.error_message)
                    } else {
                        // this.setState({
                        //     loading: false,
                        // })
                        message.success('Your transaction has been successfully.')
                        setTimeout(() => this.props.history.push('/myobservation'), 2000);
                        this.props.CLEAR_IMAGE_CATEGORY()
                    }
                }, (error) => {
                    message.error(this.state.error_message)
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                })
        });

        

    }

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }
    handleCancel = () => this.setState({ previewVisible: false })
    handleCancel2 = () => {
        this.setState({ submit_success: false });
    }

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const Detail_Category = JSON.parse(window.localStorage.getItem("Detail_Category"))
        const near_miss = JSON.parse(window.localStorage.getItem("nearmiss"))
        const Rootcause = JSON.parse(window.localStorage.getItem("Rootcause"))
        const { select_job, job, category, type_of_category, fileList, previewVisible, previewImage } = this.state
        const type_of_observe2 = this.props.location.state.type_of_observe
        const { type_of_observe, detail_unsafe1, detail_unsafe2, detail_safe1 } = this.state
        const view = this.state.mode === 'view'
        const type_of_category_ = type_of_category
        var data_table_cate_rootcause = []
        var data_table_safe_detail_category = []
        var data_table_unsafe_detail_category = []
        var count_safe_detail_category = 0
        var count_unsafe_detail_category = 0

        let DetailCategory = Detail_Category.filter(x => type_of_category.filter(t => t.cat_id === x.category_ID).length > 0)

        // Show Safe or Unsafe detail as category
        DetailCategory.map((l, i) => {
            if (l.detail !== null) {
                if (type_of_category_[i].type === "Safe" || type_of_category_[i].type === "Observed") {
                    data_table_safe_detail_category[count_safe_detail_category] = { category_name: this.state.isEng ? category[i].Category_Name_EN : category[i].Category_Name, detail: l.detail }
                    count_safe_detail_category++
                }
                if (type_of_category_[i].type === "Unsafe") {
                    data_table_unsafe_detail_category[count_unsafe_detail_category] = { category_name: this.state.isEng ? category[i].Category_Name_EN : category[i].Category_Name, detail: l.detail }
                    count_unsafe_detail_category++
                }
            }
            return true
        })

        // if observed is Unsafe then show root cause table
        if (type_of_observe2 === "Unsafe") {
            var props_rootcause = this.props.location.state.root_cause
            let root_cause_temp = props_rootcause.map(l => {
                return this.state.isEng ? Rootcause.find(x => x.Rootcause === l).Rootcause_EN : l
            })

            // console.log(props_rootcause)
            var count = 0

            type_of_category.map((l, i) => {
                if (l.type === "Unsafe") {
                    data_table_cate_rootcause[count] = { category_name: this.state.isEng ? category[i].Category_Name_EN : category[i].Category_Name, root_cause: root_cause_temp[count] }
                    count++
                }
                return true
            })
        }

        var basic_info = this.props.set_basic_info
        var time = basic_info.time
        var area = basic_info.area
        var site = basic_info.site
        var shift = basic_info.shift
        var type_of_observed_people = basic_info.type_of_observed_people

        const columns_rootcause = [
            {
                key: 'category_name',
                title: "Category",
                dataIndex: "category_name",
                width: "50%"
            },
            {
                key: 'root_cause',
                title: "Root cause",
                dataIndex: "root_cause",
                width: "50%"
            }
        ];

        const columns_safe_detail_category = [
            {
                key: 'category_name',
                title: "Category",
                dataIndex: "category_name",
                width: "50%"
            },
            {
                key: 'detail',
                title: "Safe detail",
                dataIndex: "detail",
                width: "50%"
            }
        ];

        const columns_unsafe_detail_category = [
            {
                key: 'category_name',
                title: "Category",
                dataIndex: "category_name",
                width: "50%"
            },
            {
                key: 'detail',
                title: "Unsafe detail",
                dataIndex: "detail",
                width: "50%"
            }
        ];

        return (

            <div >
                <ScrollToTop />
                <Spin spinning={this.state.loading} size="large" style={{ top: "50%" }} tip="Loading...">
                    <MenuSider title={<IntlMessages id="Summary.title" />}>
                        <div style={{ width: "100vw", minHeight: window.innerHeight - 82 }}>
                            <div style={{ width: "100%", borderTop: "1px solid rgba(0, 0, 0, 0.158)", padding: " 0 5%", fontSize: "13px" }}>
                                {
                                    (type_of_observe === "Safe") && (
                                        <div style={{ width: "100%", paddingLeft: "12px", paddingTop: "10px", paddingBottom: "5px", borderBottom: "1px solid #d9d9d9" }}>
                                            <div style={{ width: "100%", display: "inline-block", color: "black", display: "inline-block" }} key="Job">
                                                <IntlMessages id="Action.job_observed" />
                                                <div style={{ marginLeft: "10px", width: "70px", backgroundColor: "green", color: "white", borderRadius: "5px", textAlign: "center", display: "inline-block" }}>
                                                    <IntlMessages id="Action.Safe" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    (type_of_observe === "Unsafe") && (
                                        <div style={{ width: "100%", paddingLeft: "12px", paddingTop: "10px", paddingBottom: "5px", borderBottom: "1px solid #d9d9d9" }}>
                                            <div style={{ width: "100%", display: "inline-block", color: "black", display: "inline-block" }} key="Job">
                                                <IntlMessages id="Action.job_observed" />
                                                <div style={{ marginLeft: "10px", width: "70px", backgroundColor: "red", color: "white", borderRadius: "5px", textAlign: "center", display: "inline-block" }}>
                                                    <IntlMessages id="Action.Unsafe" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                <Collapse className="collapse-detail" bordered={false} defaultActiveKey={["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"]}>
                                    {
                                        (near_miss) && (
                                            <Panel header={<IntlMessages id="Summary.near_miss" />} key="1" showArrow={false} style={{ paddingTop: "0", fontSize: "13px" }}>
                                                <IntlMessages id="Summary.near_miss_this" />
                                            </Panel>
                                        )
                                    }
                                    {
                                        (fileList.length !== 0) && (
                                            <Panel header={<IntlMessages id="Summary.image" />} key="2" showArrow={false} style={{ paddingTop: "0", fontSize: "13px" }}>
                                                <Upload
                                                    listType="picture-card"
                                                    fileList={fileList}
                                                    onPreview={this.handlePreview}
                                                    onChange={this.handleChange}
                                                    className="picture-card"
                                                    disabled={view}
                                                >
                                                </Upload>
                                                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                                                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                                </Modal>
                                            </Panel>
                                        )
                                    }

                                    <Panel header={<IntlMessages id="Summary.observation_date_time" />} key="3" showArrow={false} style={{ paddingTop: "0", fontSize: "13px" }}>
                                        {this.props.set_basic_info.observation_date.slice(8, 10) + "-" + this.props.set_basic_info.observation_date.slice(5, 7) + "-" + this.props.set_basic_info.observation_date.slice(0, 4)}
                                        &nbsp;&nbsp;&nbsp; {time}
                                    </Panel>
                                    <Panel header={<IntlMessages id="Summary.shift" />} key="4" style={{ fontSize: "13px" }} showArrow={false}>
                                        <IntlMessages id={'basic.shift_' + shift} />
                                    </Panel>
                                    <Panel header={<IntlMessages id="Summary.area" />} key="5" style={{ fontSize: "13px" }} showArrow={false}>

                                        {area.map((l, i) => {
                                            return l + " / "
                                        })}
                                        {site.map((l, i) => {
                                            if ((i + 1) !== site.length) {
                                                return l + " / "
                                            } else {
                                                return l
                                            }
                                        })}

                                    </Panel>
                                    <Panel header={<IntlMessages id="Summary.site" />} key="6" style={{ fontSize: "13px" }} showArrow={false}>
                                        <ul>
                                            {
                                                type_of_observed_people.map((l, i) => {
                                                    return (
                                                        <li key={i}>
                                                            {l}
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </Panel>
                                    <Panel header={<IntlMessages id="Summary.job_type" />} key="7" style={{ fontSize: "13px" }} showArrow={false}>
                                        <ul>
                                            {
                                                select_job.map((l, i) => {
                                                    if (l.factory === 1 || l.office === 1) {
                                                        return (
                                                            <li key={i}>
                                                                {this.state.isEng ? job[i].JobType_EN : job[i].JobType1}
                                                            </li>
                                                        )
                                                    }
                                                    return null
                                                })
                                            }
                                        </ul>
                                    </Panel>
                                    {
                                        (data_table_safe_detail_category.length > 0) && (
                                            <Panel header={<IntlMessages id="Summary.safe_detail" />} key="8" style={{ fontSize: "13px" }} showArrow={false}>
                                                <Table rowKey='category_name' columns={columns_safe_detail_category} dataSource={data_table_safe_detail_category} size="small" style={{ padding: "0" }} pagination={false} />
                                            </Panel>
                                        )
                                    }
                                    {
                                        (data_table_unsafe_detail_category.length > 0) && (
                                            <Panel header={<IntlMessages id="Summary.unsafe_detail" />} key="9" style={{ fontSize: "13px" }} showArrow={false}>
                                                <Table rowKey='category_name' columns={columns_unsafe_detail_category} dataSource={data_table_unsafe_detail_category} size="small" style={{ padding: "0" }} pagination={false} />
                                            </Panel>
                                        )
                                    }

                                    {
                                        (type_of_observe === "Unsafe") && (
                                            <Panel header={<IntlMessages id="Summary.root_cause" />} key="10" style={{ fontSize: "13px" }} showArrow={false}>
                                                <Table rowKey='category_name' columns={columns_rootcause} dataSource={data_table_cate_rootcause} size="small" style={{ padding: "0" }} pagination={false} />
                                            </Panel>
                                        )
                                    }
                                    {/* {
                                        (type_of_observe === "Unsafe") && (
                                            <Panel header={<IntlMessages id="Summary.current_unsafe" />} key="11" style={{ fontSize: "13px" }} showArrow={false}>
                                                {detail_unsafe1}
                                            </Panel>
                                        )
                                    } */}
                                    {
                                        (type_of_observe === "Unsafe") && (
                                            <Panel header={<IntlMessages id="Summary.next_action_suggestion" />} key="12" style={{ fontSize: "13px" }} showArrow={false}>
                                                {detail_unsafe2}
                                            </Panel>
                                        )
                                    }
                                    {
                                        (type_of_observe === "Safe") && (
                                            <Panel header={<IntlMessages id="Summary.current_safe" />} key="13" style={{ fontSize: "13px" }} showArrow={false}>
                                                {detail_safe1}
                                            </Panel>
                                        )
                                    }

                                </Collapse>
                            </div>
                            <Modal
                                visible={this.state.submit_success}
                                title="Submit Success"
                                footer={null}
                                onCancel={this.handleCancel2}
                            >
                                <p>Thank You.</p>
                            </Modal>
                        </div>
                        <div style={{ width: "100%", textAlign: "center", position: "relative", bottom: "0", height: "48px" }} >
                            <Link to={{
                                pathname: "/newobservation_action",
                                state: { back: "Action_Unsafe", mode: this.state.mode }
                            }}>
                                <Button style={{ width: view ? "100%" : "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                    <Icon type="caret-left" style={{ position: "relative", top: "1px", right: "-4px" }} />
                                    <IntlMessages id='Back' />
                                </Button>
                            </Link>
                            {
                                !view && (
                                    <Button onClick={this.insert_newobservation_image} disabled={this.state.loading} style={{ width: "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}>
                                        <IntlMessages id='Submit' />
                                        <Icon type="caret-right" style={{ position: "relative", top: "1px", left: "-4px" }} />
                                    </Button>
                                )
                            }

                        </div>

                    </MenuSider>
                </Spin>

            </div >
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
        set_basic_info: state.set_basic_info,
        set_checklist: state.set_checklist,
    }
}
const mapDispatchProps = (dispatch) => {
    return {
        CLEAR_IMAGE_CATEGORY: () => {
            dispatch({
                type: "CLEAR_IMAGE_CATEGORY",
            })
        },
    }
}

const Newobservation_Summary = Form.create()(Summary);

export default connect(mapStatetoProps, mapDispatchProps)(Newobservation_Summary)